/**
 * KYC submission schemas.
 *
 * User submits identity documents; admin reviews and approves/rejects.
 */
import { z } from 'zod';

/** POST /api/users/kyc — submit KYC application. */
export const KycSubmitSchema = z.object({
  real_name: z.string().min(1).max(100),
  id_type: z.enum(['id_card', 'passport', 'driver_license']).default('id_card'),
  id_number: z.string().min(4).max(64),
  front_image_url: z.string().max(500).optional(),
  back_image_url: z.string().max(500).optional(),
  selfie_url: z.string().max(500).optional(),
});
export type KycSubmitRequest = z.infer<typeof KycSubmitSchema>;

/** POST /api/admin/kyc/:id/review — approve or reject. */
export const KycReviewSchema = z.object({
  action: z.enum(['approve', 'reject']),
  reject_reason: z.string().max(500).optional(),
});
export type KycReviewRequest = z.infer<typeof KycReviewSchema>;

/** GET /api/admin/kyc — list submissions. */
export const KycListQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(200).default(50),
  status: z.enum(['pending', 'approved', 'rejected']).optional(),
  user_id: z.coerce.number().int().positive().optional(),
});
export type KycListQuery = z.infer<typeof KycListQuerySchema>;
